'use strict';

export default class Tile {

    constructor(tileDom) {
        this._tileDom = tileDom;
        this._position = parseInt(tileDom.getAttribute("data-index")) + 1;
        this._dreson = tileDom.getAttribute('data-dreson');
        this._urlPath = tileDom.querySelector(".promo_shoppromo-small--link").getAttribute("href");
        this._variationId = tileDom.getAttribute('data-variation-id');
        this._teslaModel = tileDom.getAttribute("data-source");
        this._featureTrackingLabels = JSON.parse(tileDom.getAttribute("data-feature-tracking-tile-labels"));
    }

    getWidth() {
        return this._tileDom.offsetWidth;
    }

    setIsTracked() {
        this._tileDom.setAttribute("data-is-tracked", true);
    }

    isTracked() {
        return this._tileDom.getAttribute("data-is-tracked") === "true";
    }

    get tileDom() {
        return this._tileDom;
    }

    get position() {
        return this._position;
    }

    get dreson() {
        return this._dreson;
    }

    get urlPath() {
        return this._urlPath;
    }

    get variationId() {
        return this._variationId;
    }

    get teslaModel() {
        return this._teslaModel;
    }

    get featureTrackingLabels() {
        return this._featureTrackingLabels;
    }
}